import React, { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [showMediaModal, setShowMediaModal] = useState(false);
  // Footer data objects for better organization
  const footerData = {
    company: {
      logo: "/assets/images/logo.png",
      description: "Digital Exam, Simplified ...!",
      socialLinks: [
        {
          href: "https://www.facebook.com/CoemptEduTechPvtLtd",
          icon: "fa-brands fa-facebook-f",
        },
        {
          href: "https://x.com/coempt_eduteck",
          icon: "fa-brands fa-twitter",
        },
        {
          href: "https://www.linkedin.com/in/coempt-edu-teck/",
          icon: "fa-brands fa-linkedin-in",
        },
        {
          href: "https://www.youtube.com/@CoemptEduTeck",
          icon: "fa-brands fa-youtube",
        },
        {
          href: "https://www.instagram.com/coempteduteck/",
          icon: "fa-brands fa-instagram",
        },
      ],
    },

    menu: {
      title: "Menu",
      links: [
        { to: "/", label: "Home" },
        { to: "/management", label: "Board of Directors" },
        { to: "/oursolutions", label: "Solutions" },
      ],
    },

    quickLinks: {
      title: "Quick Link",
      links: [
        { to: "/career", label: "Current Openings" },
        { type: "modal", label: "Media & Press" },
        { to: "/contact", label: "Contact Us" },
      ],
    },

    contact: {
      title: "Contact Us",
      address: "COEMPT EDU TECK PVT. LTD.,",
      smallAddress: "Madhura Nagar, Yousufguda, Hyderabad, Telangana 500038",
      contactInfo: [
        {
          icon: "fa-regular fa-envelope",
          title: "E-mail:",
          content: "info@coempt.in",
          href: "mailto:techsupport@coempt.in",
        },
        {
          icon: "fa-solid fa-mobile-screen-button",
          title: "Mobile Number:",
          content: "+91-7660912111",
          href: "tel:+917660912111",
        },
        {
          icon: "fa-solid fa-phone",
          title: "Phone Call:",
          content: "+91-040 23750190",
          href: "tel:+917660912111",
        },
      ],
    },

    shapes: [
      {
        className: "footer__shape-regular-left wow slideInLeft",
        delay: "00ms",
        src: "/assets/images/shape/footer-regular-left.png",
        alt: "shape",
      },
      {
        className: "footer__shape-solid-left wow slideInLeft",
        delay: "200ms",
        src: "/assets/images/shape/footer-solid-left.png",
        alt: "shape",
        extraClass: "sway_Y__animation",
      },
      {
        className: "footer__shape-solid-right wow slideInRight",
        delay: "00ms",
        src: "/assets/images/shape/footer-regular-right.png",
        alt: "shape",
        extraClass: "sway_Y__animation",
      },
      {
        className: "footer__shape-regular-right wow slideInRight",
        delay: "200ms",
        src: "/assets/images/shape/footer-solid-right.png",
        alt: "shape",
      },
    ],

    copyright: {
      text: '© All Copyright  2026 by',
      companyLink: {
        to: "/",
        label: "Coempt Eduteck Pvt Ltd. - Last Updated: May 2026",
      },
      policyLinks: [
        { to: "/termsandconditions", label: "Terms & Condition" },
        { to: "/privacypolicy", label: "Privacy Policy" }, 
      ],
    },
  };

  // Animation configurations
  const animations = [
    { delay: "00ms", duration: "1500ms" },
    { delay: "200ms", duration: "1500ms" },
    { delay: "400ms", duration: "1500ms" },
    { delay: "600ms", duration: "1500ms" },
  ];

  return (
    <footer className="footer-area secondary-bg">
      {/* Background Shapes */}
      {footerData.shapes.map((shape, index) => (
        <div
          key={index}
          className={shape.className}
          data-wow-delay={shape.delay}
          data-wow-duration="1500ms"
        >
          <img
            className={shape.extraClass || ""}
            src={shape.src}
            alt={shape.alt}
          />
        </div>
      ))}

      <div className="footer__shadow-shape">
        <img src="/assets/images/shape/footer-shadow-shape.png" alt="shadow" />
      </div>

      {/* Main Footer Content */}
      <div className="container">
        <div
          className="footer__wrp pt-100 pb-100"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* Company Info Section */}
          <div
            className="footer__item item-big wow fadeInUp"
            data-wow-delay={animations[0].delay}
            data-wow-duration={animations[0].duration}
            style={{ flex: "1 1 250px", minWidth: "250px" }}
          >
            <Link to="/" className="logo mb-30">
              <img src={footerData.company.logo} alt="company logo" />
            </Link>
            <p style={{ textTransform: "capitalize", fontSize: 17 }}>
              {footerData.company.description}
            </p>
            <div className="social-icon" style={{ marginTop: "15px" }}>
              {footerData.company.socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "10px" }}
                >
                  <i className={social.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Menu Links Section */}
          <div
            className="footer__item item-sm wow fadeInUp"
            data-wow-delay={animations[1].delay}
            data-wow-duration={animations[1].duration}
            style={{ flex: "1 1 150px", minWidth: "150px" }}
          >
            <h3 className="footer-title">{footerData.menu.title}</h3>
            <ul style={{ color: "white", paddingLeft: "0", listStyle: "none" }}>
              {footerData.menu.links.map((link, index) => (
                <li key={index} style={{ marginBottom: "8px" }}>
                  <Link to={link.to}>
                    <i className="fa-regular fa-angles-right me-1" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Section */}
          <div
            className="footer__item item-sm wow fadeInUp"
            data-wow-delay={animations[2].delay}
            data-wow-duration={animations[2].duration}
            style={{ flex: "1 1 150px", minWidth: "150px" }}
          >
            <h3 className="footer-title">{footerData.quickLinks.title}</h3>

            <ul style={{ color: "white", paddingLeft: "0", listStyle: "none" }}>
  {footerData.quickLinks.links.map((link, index) => (
    <li key={index} style={{ marginBottom: "8px" }}>
      {link.type === "modal" ? (
        <button
          type="button" aria-label="Open Media & Press information"
          onClick={() => setShowMediaModal(true)}
          style={{
            background: "none",
            border: "none",
            color: "white",
            padding: 0,
            cursor: "pointer",
            fontSize: "inherit",
            fontFamily: "inherit",
            textAlign: "left",
          }}
        >
          <i className="fa-regular fa-angles-right me-1" />
          {link.label}
        </button>
      ) : (
        <Link to={link.to}>
          <i className="fa-regular fa-angles-right me-1" />
          {link.label}
        </Link>
      )}
    </li>
  ))}
</ul>

          </div>

          {/* Contact Section */}
          <div
            className="footer__item item-big wow fadeInUp"
            data-wow-delay={animations[3].delay}
            data-wow-duration={animations[3].duration}
            style={{ flex: "1 1 250px", minWidth: "250px" }}
          >
            <h3 className="footer-title">{footerData.contact.title}</h3>
            <p style={{ fontSize: 14 }}>{footerData.contact.address}</p>
            <p style={{ fontSize: 17, marginTop: -15 }}>
              {footerData.contact.smallAddress}
            </p>
            <ul
              className="footer-contact"
              style={{ padding: "0", listStyle: "none" }}
            >
              {footerData.contact.contactInfo.map((contact, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    alignItems: "center",
                  }}
                >
                  <i className={contact.icon} style={{ marginRight: "10px" }} />
                  <div className="info">
                    <h6 style={{ margin: "0 0 2px 0" }}>{contact.title}</h6>
                    <a href={contact.href}>{contact.content}</a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer__copyright">
        <div className="container">
          <div className="d-flex gap-1 flex-wrap align-items-center justify-content-md-between justify-content-center">
            <p
              style={{ color: "white" }}
              className="wow fadeInDown"
              data-wow-delay={animations[0].delay}
              data-wow-duration={animations[0].duration}
            >
              {footerData.copyright.text}{" "}
              <Link
                style={{ color: "white" }}
                to={footerData.copyright.companyLink.to}
              >
                {footerData.copyright.companyLink.label}
              </Link>
            </p>
            <ul
              style={{ color: "white" }}
              className="d-flex align-items-center gap-4 wow fadeInDown"
              data-wow-delay={animations[1].delay}
              data-wow-duration={animations[1].duration}
            >
              {footerData.copyright.policyLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>


{/* Media & Press Modal */}
{showMediaModal && (
  <>
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 1055,
      }}
      onClick={() => setShowMediaModal(false)}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title">
              Media & Press
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={() => setShowMediaModal(false)}
            />
          </div>

          <div className="modal-body">
            <p>
              For press, media, public relations,
              corporate communications, and official
              statements, please contact:
            </p>

            <div
              style={{
                background: "#f8f9fa",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "15px",
              }}
            >
              <strong>Email:</strong>{" "}
              <a href="mailto:media@coempt.in">
                media@coempt.in
              </a>
            </div>

            <p className="mb-0">
              Our team will respond to your inquiry
              as soon as possible.
            </p>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={() => setShowMediaModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      className="modal-backdrop fade show"
      style={{ zIndex: 1050 }}
    />
  </>
)}
{/* Fixed Bottom Public Notice */}
      <div className="public-notice-bar">
        <div className="public-notice-label">
          <i className="fa-solid fa-bullhorn me-2" />
          PUBLIC NOTICE
        </div>

        <div className="public-notice-content">
          <div className="public-notice-track">
  <a
    href="https://epaper.eenadu.net/Home/Index?date=04/08/2026&eid=3&pid=3535645"
    target="_blank"
    rel="noopener noreferrer"
  >
    Public Notice in Eenadu dated 4th Aug, 2026, Hyderabad - Telangana
  </a>

  <span className="notice-separator"> | </span>

  <a
    href="https://epaper.eenadu.net/Home/Index?date=04/08/2026&eid=2&pid=3535231"
    target="_blank"
    rel="noopener noreferrer"
  >
    Public Notice in Eenadu dated 4th Aug, 2026, Andhra Pradesh
  </a>

  <span className="notice-separator"> | </span>

  <a
    href="http://epaper.deccanchronicle.com/articledetailpage.aspx?id=19934618"
    target="_blank"
    rel="noopener noreferrer"
  >
    Public Notice in Deccan Chronicle dated 4th Aug, 2026, AP & Telangana
  </a>
</div>
        </div>
      </div>

    </footer>
    
  );
};

export default Footer;

